module.exports = __webpack_public_path__ + "0d3d7e6143c9669f9d77af6c9ca6edd0.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/grapplin-klaw.webm
// module id = 635
// module chunks = 0